import {SplashState} from './splashState';

let appModule = angular.module('deliveryCreate.app');
appModule.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
    $stateProvider.state(SplashState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/splash/bootstrap.ts
 **/